export default class EventPlace {
    public id: string;
    public title: string;
    public address: string;
  
    constructor() {
      this.id = "";
      this.title = "";
      this.address = "";
    }
  }


// WEBPACK FOOTER //
// ./src/api/eventPlaceEntity.ts